module.exports = __webpack_public_path__ + "static/media/banner-6.b6155ccd.jpg";